/* eslint-disable no-console */
import { Directive, ElementRef, Input, Renderer2, OnInit } from '@angular/core';

@Directive({ selector: '[mgpBackgroundClass]' })
export class BackgroundClassDirective implements OnInit {

    
    @Input() mgpBackgroundClass?: number; 
    
    constructor(public elementRef:ElementRef, private renderer2: Renderer2) {
    }

    ngOnInit(): void {
        this.renderer2.addClass(this.elementRef.nativeElement,  this.generateBgClass(this.mgpBackgroundClass));
    }
   
    private generateBgClass(id = 1): string {
        return "bg" + (id % 7 + 1).toString();
    }

}